import { useRef } from 'react'
import Cross from '../icons/Cross';
import { ToastContextType } from '../context/ToastProvider';
import useToast from '../hook/useToast';

const Toast = () => {
    const { toast, setToast }: ToastContextType = useToast();
    const toatRef = useRef<HTMLDivElement | null>(null);

    const onClose = () => {
        setToast({
            show: false,
            title: ""
        });
    }

    return (
        <div
            ref={toatRef}
            className={`fixed top-[82px] right-4 z-[100000] transition-all duration-500 ease-in-out ${toast.show ? 'translate-x-0 opacity-100' : 'translate-x-[200%] opacity-0'} border border-yellow-500 text-black bg-yellow-100 rounded shadow-md`}
        >
            <div className="px-5 py-2.5 flex items-center space-x-4">
                <div className="flex items-center space-x-2">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-5 w-5 text-yellow-700"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                    >
                        <path
                            fillRule="evenodd"
                            d="M8.257 3.099c.765-1.36 2.681-1.36 3.446 0l6.518 11.604c.75 1.336-.213 3.011-1.723 3.011H3.462c-1.51 0-2.473-1.675-1.723-3.011L8.257 3.1zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-5a1 1 0 00-.993.883L9 9v2a1 1 0 001.993.117L11 11V9a1 1 0 00-1-1z"
                            clipRule="evenodd"
                        />
                    </svg>
                    <span>{toast?.title}</span>
                </div>

                <Cross closeModal={onClose} />
            </div>
        </div>
    )
}

export default Toast
